
export function logout(autoLoginDel) {
	return {
		type: "LOGOUT",
		payload: {
			autoLoginDel: autoLoginDel,
		}
	}
}
